import OEIconCodes from '../../../lib/oe-icon-codes';
import {OEObjectModelValueTypes, OEObjectModelValueCellStyleOptions} from '../../elements/object-model-value-edit/oe-object-model-value-edit-model';
import {OEFunctionFragmentType} from './function/oe-function-model';
import {OESmartAttributeType, OESmartAttributeIcons, OESmartAttributeParameterModel, OESmartAttributeHelperClass} from './smart-attribute/oe-smart-attribute-model';

//
export const OENoteAttributeType = Object.assign({}, OESmartAttributeType, {
    noteDummy:                              10000,
    noteQuizQuest:                          10001,
    noteUserRef:                            10002,
    noteNoteUserRef:                        10003,
    noteQuizEval:                           10004,
    notePresQuizEval:                       10005,
});

//
export const OENoteAttributeIcons = Object.assign({}, OESmartAttributeIcons, {
    noteDummy:                              '\u00FF',
    noteQuizQuest:                          '\uF0E7',
    noteQuizEval:                           {code: '\uF0E7', subCode: '\uF123'},
    notePresQuizEval:                       {code: '\uF0E7', subCode: '\uF123', subCode2: OEIconCodes.presentation},
});

//
export const OENoteAttributeParameterModel = Object.assign({}, OESmartAttributeParameterModel, {

    noteQuizQuest: {
        texts:                              {type: OEObjectModelValueTypes.stringArray, showType: false},
        active:                             {type: OEObjectModelValueTypes.bool, allowUndefined: true, showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]},
        attachedComponentIDs:               {type: OEObjectModelValueTypes.string, undefinedEditable: true, showType: false}
    },

    noteQuizEval: {
        reference: {
            type:                           OEObjectModelValueTypes.group,
            label:                          'Referencing',
            subItems: {
                userRefs:                   {type: OEObjectModelValueTypes.string, allowUndefined: true, label: 'Note User Reference', showType: false},
                glob:                       {type: OEObjectModelValueTypes.bool, label: 'Enable Globbing', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]}
            }
        },
        persist:                            {type: OEObjectModelValueTypes.bool, label: 'Persist', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]}
    },

    notePresQuizEval: {
        reference: {
            type:                           OEObjectModelValueTypes.group,
            label:                          'Referencing',
            subItems: {
                userRefs:                   {type: OEObjectModelValueTypes.string, allowUndefined: true, label: 'Note User Reference', showType: false},
                glob:                       {type: OEObjectModelValueTypes.bool, label: 'Enable Globbing', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]}
            }
        },
        persist:                            {type: OEObjectModelValueTypes.bool, label: 'Persist', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]}
    }
});

//
export const OENoteAttributeHelper = new OESmartAttributeHelperClass(OENoteAttributeType, OENoteAttributeIcons, OENoteAttributeParameterModel);

OENoteAttributeHelper.addAttributeMenuTypes = [
    OESmartAttributeType.debugOutput,
    OENoteAttributeType.noteQuizQuest,
    {type: OENoteAttributeType.noteQuizEval, allowMultipleInstances: false, incompatibleTypes: OENoteAttributeType.notePresQuizEval},
    {type: OENoteAttributeType.notePresQuizEval, allowMultipleInstances: false, incompatibleTypes: OENoteAttributeType.noteQuizEval}
];

OENoteAttributeHelper.addEventFunctionMenuTypes = [
    {type: OEFunctionFragmentType.debugOutput, allowMultipleInstances: true},
    {type: OEFunctionFragmentType.setNoteText, allowMultipleInstances: true},
    {type: OEFunctionFragmentType.changeNoteProps, allowMultipleInstances: true},
    {type: OEFunctionFragmentType.applyNoteAddState, allowMultipleInstances: true},
    OEFunctionFragmentType.saveNote,
    {type: OEFunctionFragmentType.triggerNoteAttrSignal, allowMultipleInstances: true},
    {type: OEFunctionFragmentType.changePresNoteProps, allowMultipleInstances: true},
    {type: OEFunctionFragmentType.applyPresNoteAddState, allowMultipleInstances: true},
    {type: OEFunctionFragmentType.triggerPresNoteAttrSignal, allowMultipleInstances: true},
    {type: OEFunctionFragmentType.changeSlideProps, allowMultipleInstances: true},
    OEFunctionFragmentType.changeActiveSlide,
    {type: OEFunctionFragmentType.setPresTime, allowMultipleInstances: true},
    OEFunctionFragmentType.userNotification,
    OEFunctionFragmentType.applyPreset,
    {type: OEFunctionFragmentType.changeComponent, allowMultipleInstances: true},
    OEFunctionFragmentType.openLink,
];